module.exports = __webpack_public_path__ + "img/homekv5.f92bcd47.jpg";